// Import LESS and CSS
import "@babel/polyfill";
import "../../physee-semantic-ui/semantic.less";
import "../../node_modules/swiper/dist/css/swiper.css";
// Import JS
import fetchChartDataAndUpdate from "./modules/charts";

import "./modules/physee-semantic";
import setupSwiper from "./modules/swiper";
import displayWeather from "./modules/weather";

setupSwiper($(".swiper-container"));
displayWeather($("#weather"));
fetchChartDataAndUpdate($('#graph'));
setInterval(() => {
  // Refresh weather & dashboard every 5 minutes
  displayWeather($("#weather"));
}, 60 * 1000 * 5);

window.setInterval(() => {
  fetchChartDataAndUpdate($('#graph'));
}, 60 * 1000 * 60);



// WEBPACK FOOTER //
// ./public/javascripts/EESYApp.js